import { render, staticRenderFns } from "./ProcessMenu.vue?vue&type=template&id=6f6c2095&scoped=true"
import script from "./ProcessMenu.vue?vue&type=script&lang=js"
export * from "./ProcessMenu.vue?vue&type=script&lang=js"
import style0 from "./ProcessMenu.vue?vue&type=style&index=0&id=6f6c2095&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6c2095",
  null
  
)

export default component.exports